export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const MISSING_INFO = "/missinginfo";
export const PASSWORD_FORGET = "/pw-forget";
export const HOME = "/home";
export const ACCOUNT = "/account";
